import React, { useState } from "react";
import { Container, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import { toast } from "react-toastify";
import styled from "styled-components";

import Tabs from "../../common/Tabs";
import { useApiGet } from "../../../hooks/useApi";
import numeral from "numeral";
import SubInternalLayout from "../../layout/SubInternalLayout";

const StyledTr = styled.tr`
  cursor: pointer;

  &:hover {
    background: var(--border-color);
  }
`;

const Payouts = () => {
  const [page] = useState(1);
  const navigate = useNavigate();

  const { isLoading, data } = useApiGet(
    "payouts",
    "/payouts",
    { page, limit: 10 },
    { staleTime: 5000, onError: (err) => toast.error(err.message) }
  );

  const renderList = (list, emptyMsg) => {
    if (list.length === 0) {
      return <p className="text-center lead">{emptyMsg}</p>;
    }

    return (
      <Table>
        <thead>
          <tr>
            <th>STARTED ON</th>
            <th>STATUS</th>
            <th>AMOUNT</th>
            <th>ARRIVING ON</th>
          </tr>
        </thead>
        <tbody>
          {list.map((row, index) => {
            return [
              <StyledTr key={index}>
                <td>
                  {moment(row.created * 1000).format("MMM D, YYYY")}
                </td>
                <td>
                  {row.status}
                </td>
                <td>
                  {numeral(row.amount / 100).format("$0,0.00")}
                </td>
                <td>
                  {moment.utc(row.arrival_date * 1000).format("MMM D, YYYY")}
                </td>
              </StyledTr>,
              row.jobRequestEvents.length > 0 && <StyledTr key={`${index}-payment-intent`}>
                <td colSpan={4} className="p-3 bg-secondary">
                  <table className="w-100">
                    <tbody>
                      {row.jobRequestEvents.map(jobRequestEvent => (
                        <tr key={`${index}-payment-intent-${jobRequestEvent._id}`} onClick={() => navigate(`/bookings/${jobRequestEvent.jobRequest}`)}>
                          <td className="text-muted">
                            <small>
                              {moment(jobRequestEvent.startDate).format("MMM D, YYYY h:mm A")} - {moment(jobRequestEvent.endDate).format("h:mm A")} with {jobRequestEvent.customer.name}
                            </small>
                          </td>
                          <td className="text-muted">
                            <small>
                              {numeral(jobRequestEvent.completedAmount - jobRequestEvent.completedFeeAmount).format("$0,0.00")}
                            </small>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </td>
              </StyledTr>
            ];
          })}
        </tbody>
      </Table>
    );
  };

  const totalPayouts = data?.payouts?.filter(payout => payout.status === 'paid').reduce((acc, curr) => acc + curr.amount, 0) || 0;
  const pendingBalance = data?.balance?.pending.reduce((acc, curr) => acc + curr.amount, 0) || 0;
  const availableBalance = data?.balance?.available.reduce((acc, curr) => acc + curr.amount, 0) || 0;

  return (
    <SubInternalLayout title={`Payouts`}>
      <Helmet>
        <title>Payouts | Account | Manana</title>
        <meta name="description" content="Manana Help" />
      </Helmet>
      <Container>
        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="d-flex flex-column flex-sm-row gap-4 mb-5">
              <div className="p-2 p-sm-4 bg-secondary rounded-3 w-100">
                <div><strong>Total Payouts</strong></div>
                <div className="text-lg">{numeral(totalPayouts / 100).format("$0,0.00")}</div>
              </div>
              <div className="p-2 p-sm-4 bg-secondary rounded-3 w-100">
                <div><strong>Pending Payout</strong></div>
                <div className="text-lg">{numeral((pendingBalance + availableBalance) / 100).format("$0,0.00")}</div>
              </div>
            </div>
            <Tabs
              tabs={[
                {
                  label: "HISTORY",
                  content: renderList(
                    data.payouts,
                    "You have not received any payouts yet."
                  ),
                },
              ]}
            />
          </>
        )}
      </Container>
    </SubInternalLayout>
  );
};

export default Payouts;
